/**
 * A global namespace for `pointermove` event.
 * @type {string}
 */
const pointermoveEvent = 'pointermove';
export default pointermoveEvent;
